import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { Observable, Subject } from 'rxjs';
import { PolicyQueryService } from '../../services/policy-query.service';
import { AdminUserService, ClaimApi } from '../../services/admin-user.service';
import { takeUntil } from 'rxjs/operators';
import routejson from './routejson.json';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'nav-bar-top',
  templateUrl: './nav-bar-top.component.html',
  styleUrls: ['./nav-bar-top.component.scss']
})
export class NavBarTopComponent implements OnInit {
  isNavbarCollapsed = true;
  authenticated: Observable<boolean>;
  policyQuery: any;
  routemap: any = routejson;
  returnUrl: string = '/';
  loginPage: boolean = true;
  loggedInUser: string;

  isadmin : ClaimApi = null;

  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private loginService: LoginService,
    private policyQueryService: PolicyQueryService,
    private userAdminService: AdminUserService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.authenticated = this.loginService.authenticated;


    this.loginService.loggedInUser.subscribe(user => {
      this.loggedInUser = user;
    })

    this.loginService.authenticated
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(authenticated => {
      if (authenticated) {
        this.policyQueryService.getPolicyQuery();
      }
    });

    this.userAdminService.isAdmin
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(isUserAdmin => {
      if (isUserAdmin) {
        this.isadmin = isUserAdmin;
      }
    });
    
    this.policyQueryService.currentPolicyQuery
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(policyQuery => {
      if (policyQuery) {
        this.policyQuery = policyQuery;
        if (this.router.url == '/login' || this.router.url == '/') {
          if (this.policyQuery['api/Appropriator'].canAccess) {
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/demand';  // starter page
          } else {
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/sponsor-portal';
          }
        } else {
          this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.router.url;
        }
        this.router.navigateByUrl(this.returnUrl);
      }
    })

  }

  checkIsLogin() {
    var re = new RegExp('/login*', 'g');
    if (re.test(this.router.url)) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
